import React, { useMemo } from "react";
import "./LatestBlog.css";
import RichTextContent, { CmsText } from "../../../../RichTextContent/RichTextContent";
import arrow from "../../../../../assets/icons/arrow.png";
import { Link } from "react-router-dom";
import { resolveMediaUrl } from "../../../../../utils/mediaUrl";
import { stripRichText } from "../../../../../utils/richText";

const LatestBlog = ({ articles = [], currentSlug }) => {
  const posts = useMemo(
    () =>
      articles
        .filter((item) => item.slug && item.slug !== currentSlug)
        .slice(0, 3),
    [articles, currentSlug]
  );

  if (posts.length === 0) return null;

  return (
    <section className="latestblog">
      <div className="latestblog__container">
        <div className="latestblog__top">
          <div>
            <span className="latestblog__label">Our blog</span>
            <h2>Lastest blog posts</h2>
            <p>
              Tool and strategies modern teams need to help their companies grow.
            </p>
          </div>

          <Link to="/insights" className="buttonclip latestblog__btn">
            View all posts
          </Link>
        </div>

        <div className="latestblog__grid">
          {posts.map((item) => {
            const imageSrc = resolveMediaUrl(item.image);

            return (
              <Link
                key={item.slug}
                to={`/insights/${item.slug}`}
                className="latestblog-card"
              >
                {imageSrc ? (
                  <div className="latestblog-card__image">
                    <img src={imageSrc} alt={stripRichText(item.title)} />
                  </div>
                ) : null}

                <div className="latestblog-card__content">
                  {item.category ? (
                    <CmsText
                      content={item.category}
                      as="span"
                      className="latestblog-card__category"
                    />
                  ) : null}

                  <div className="latestblog-card__title-row">
                    {item.title ? <CmsText content={item.title} as="h3" /> : null}
                    <img src={arrow} alt="" />
                  </div>

                  {item.desc ? (
                    <RichTextContent content={item.desc} />
                  ) : null}
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default LatestBlog;
